import { Api } from '@recargas-dominicanas/core/api';
import type { BusinessSales } from '@recargas-dominicanas/core/types';

export class SalesApi extends Api {

  public static async getBalance() {
    return this.get<{ amount: number }>('/dist/sales/balance');
  }

  public static async getSales(params?: { startDate: string; endDate: string; period: 'day' | 'month' }) {
    return this.get<BusinessSales>('/dist/sales', { params });
  }
}
